import styled from '@emotion/styled';
import { ExpandableRow } from '../../custom-dynamic-result-table/src/expandable-row';

export const Container = styled(ExpandableRow)<{
  expandableRowLeftPosition?: string;
  containerPaddingLeft?: string;
}>`
  /** added !important to override the default top and bottom borders */
  position: relative;
  border-bottom: none !important;
  border-top: none !important;

  table > tbody > tr {
    &:hover {
      background-color: unset !important;
    }

    td {
      height: 0px !important; // to override the default row height of 50px

      span {
        position: relative;
        left: ${(props) => props.expandableRowLeftPosition ?? '28px'};
      }
    }
  }

  .expandable-row-button {
    left: ${(props) => props.expandableRowLeftPosition ?? '40px'};
    table > tbody > tr > td {
      height: 0px !important; // to override the default row height of 50px
    }
  }
  > td {
    height: var(--ds-space-300, $spacing4) !important; // to override the default cell height of 50px
  }
`;

export const AppSubRow = styled.tr<{ paddingLeft?: string }>`
  > td:first-child {
    padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : '44px')} !important;
  }
`;
